import React from 'react'
import Paper from '@material-ui/core/Paper'
import { useTheme } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import Button from '@material-ui/core/Button'
import Phone from '@material-ui/icons/Phone'
import Email from '@material-ui/icons/Email'
import Room from '@material-ui/icons/Room'


export const Footer = () => {
    const theme = useTheme();
    const classes = useStyles(theme);
    return (
        <div className={classes.container}>
            <div className={classes.buttonwrapper}>
              <Button 
                startIcon={<Phone className={classes.icon}/>}
                href={"tel: 070-404 02 23"}
                >
                070-404 02 23
              </Button>
            </div>
            <div className={classes.buttonwrapper}>
              <Button 
                startIcon={<Email className={classes.icon}/>}
                href={"mailto: Hedi_Jamal@hotmail.com"}
                >
                  Hedi_Jamal@hotmail.com
                </Button>
            </div>
            <div className={classes.buttonwrapper}>
              <Button 
                startIcon={<Room className={classes.icon}/>}
                onClick={() => window.open("https://www.google.se/maps/place/Kranbalksgatan+4,+721+38+V%C3%A4ster%C3%A5s/@59.6179505,16.4546236,17z/data=!3m1!4b1!4m5!3m4!1s0x465e6395903a719f:0x28bb55905805c296!8m2!3d59.6179478!4d16.4568123")}
                >
                  Kranbalksgatan 4, 72138 Västerås
                </Button>
            </div>
        </div>
    )
}

const useStyles = makeStyles({
    container:theme => ({
        display: 'flex',
        flexDirection: 'column',
        flex: '0 0 auto',
        backgroundColor: theme.palette.primary.main
    }),
    buttonwrapper: {
      display: 'flex',
      flexDirection: 'row'
    },
    icon: theme => ({
      color: theme.palette.icons.main
    })
})